import { memo, ReactNode } from 'react'

import classnames from 'classnames'

import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'

interface Props {
  children: ReactNode,
  label?: ReactNode,
  className?: string,
  htmlFor?: string
}

const FormSection = ({ children, label, className, htmlFor }: Props) => (
  <div
    data-test="form-section"
    className={classnames('hot-form', className)}>
    {
      label && (
        <label
          htmlFor={htmlFor}
          data-test="label"
          className="hot-form__label _w-full">
          {label}
        </label>
      )
    }
    {children}
  </div>
)

export default memo(FormSection)
